import type { HttpEvent } from '@angular/common/http';
import type { HttpInterceptorFn } from '@angular/common/http';
import { HttpResponse } from '@angular/common/http';
import type { Observable } from 'rxjs';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { filter } from 'rxjs/operators';
import { shareReplay } from 'rxjs/operators';

import { API_ENDPOINT } from '../../../constants/api-endpoint.constants';

const reportCache = new Map<string, Observable<HttpEvent<unknown>>>();

export function clearAiqReportCache(): void {
  reportCache.clear();
}

export const aiqReportCacheInterceptor: HttpInterceptorFn = (request, next) => {
  if (request.method !== 'GET' || !request.url.includes('/' + API_ENDPOINT.AIQ_ASSESSMENTS + '/')) return next(request);
  const key = request.urlWithParams;
  const cached = reportCache.get(key);
  if (cached) return cached;
  const response = next(request).pipe(
    filter(event => event instanceof HttpResponse),
    catchError(error => {
      reportCache.delete(key);
      return throwError(() => error);
    }),
    shareReplay(1)
  );
  reportCache.set(key, response);
  return response;
};
